import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Tent, Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("parkscanner@outlook.com");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      const data = await api.login(email, password);
      localStorage.setItem("parkscanner_token", data.token);
      localStorage.setItem("parkscanner_admin", data.email);
      navigate("/admin");
    } catch (ex) {
      const detail = ex?.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sand flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-border rounded-2xl p-8 shadow-sm">
        <div className="flex items-center gap-2 mb-6">
          <span className="w-10 h-10 rounded-lg bg-forest text-white flex items-center justify-center">
            <Tent className="w-5 h-5" />
          </span>
          <div>
            <div className="font-display font-bold text-xl">ParkScanner</div>
            <div className="text-xs uppercase tracking-[0.18em] font-bold text-forest">Admin</div>
          </div>
        </div>

        <h1 className="font-display font-extrabold text-3xl mb-2">Sign in</h1>
        <p className="text-ink/60 text-sm mb-6">Admin access only. JWT bearer auth.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label-eyebrow block mb-1">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-sand border border-border rounded-lg px-4 py-3 outline-none focus:border-forest text-sm"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="label-eyebrow block mb-1">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-sand border border-border rounded-lg px-4 py-3 outline-none focus:border-forest text-sm"
              data-testid="admin-login-password"
            />
          </div>
          {err && <div className="text-sm text-destructive bg-destructive/10 rounded-lg px-3 py-2" data-testid="admin-login-error">{err}</div>}
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="admin-login-submit">
            <Lock className="w-4 h-4" />{loading ? "Signing in..." : "Sign in"}
          </button>
        </form>

        <button onClick={() => navigate("/")} className="text-xs text-ink/50 hover:text-forest mt-6 block mx-auto">
          ← Back to ParkScanner
        </button>
      </div>
    </div>
  );
}
